import { PAGE_TYPE } from '../page-types'

/* ------- MICROFRONT - INSCRIPTION ------- */

export const signInRoutes = [
  {
    path: '/registration',
    name: 'register',
    meta: {
      inscriptionFlow: true,
      doNotStoreRoute: true,
      analyticsPageType: PAGE_TYPE.SIGN_UP,
      layout: 'minimal',
    },
  },
  {
    path: '/registration/accept-gcu',
    name: 'accept-cgu-agri',
    component: () => import('@b2ag/micro-front-legals/app'),
    props: () => ({
      microFrontName: 'legals',
      viewName: 'accept-cgu',
    }),
    meta: {
      inscriptionFlow: true,
      private: true,
      doNotStoreRoute: true,
      layout: 'minimal',
    },
  },

  {
    path: '/registration/link-partner',
    name: 'account-add-cooperative',
    component: () => import('@b2ag/micro-front-signup/app'),
    props: () => {
      return {
        microFrontName: 'signup',
        viewName: 'add-partner',
      }
    },
    meta: {
      inscriptionFlow: true,
      private: true,
      doNotStoreRoute: true,
      layout: 'minimal',
    },
  },
  {
    path: '/profiles/confirm-association',
    name: 'profile-confirmation',
    component: () => import('@b2ag/micro-front-signup/app'),
    props: () => {
      return {
        microFrontName: 'signup',
        viewName: 'profile-confirmation',
      }
    },
    meta: {
      inscriptionFlow: true,
      doNotStoreRoute: true,
      analyticsPageType: PAGE_TYPE.PROFILE,
      layout: 'minimal',
    },
  },
]
